import { request, request_blob, patch_request, patch_get, ad_request } from './request';
import request_body from './request_body';
// import * as echarts from "echarts";


export default { 
	request_body,
	setRequestUrl(url) {
		window.localStorage.setItem("rqurl", url);
		// request_body.url = url;
	},
	getPatchUrl() {
		return window.update_host;
	},
	async login(data, token2, permission) {
		request_body.logout();
		request_body.login(data, token2, permission);
	},
	logout() {
		request_body.logout();
	},
	async loginAdmin(form) {
		return request("/login/login_admin", form);
	},
	async getAppList() {
		return request("/app/apps");
	},
	async getApps(name, page, limit) {
		return request("/app/app_list", {name, page, limit});
	},
	async getOptimizers() {
		return request("/app/get_optimizers");
	},
	async setAppOptimizer(id, uid) {
		return request("/app/set_app_optimizer", {id, uid});
	},
	async saveApp(app_name, package_name) {
		return request("/app/save_app", {app_name, package_name});
	},
	async getReports(params) {
		return request("/app/get_reports", params);
	},
	async getWhiteList() {
		return request("/app/get_white_list");
	},
	async saveWhite(params) {
		return request("/app/save_white", params);
	},
	async deleteWhite(gaid) {
		return request("/app/delete_white", {gaid});
	},
	async getAppRoas(package_name, date_from, date_end, country) {
		return request("/app/get_roas_report", {package_name, date_from, date_end, country});
	},
	async getAdReports(package_name, start_date, end_date, country, ad_type) {
		return request("/app/get_ad_reports", {package_name, start_date, end_date, country, ad_type});
	},
	async getAdPlaceReports(package_name, start_date, end_date, ad_ids, countries, ad_types) {
		return request("/app/get_ad_place_reports", {package_name, start_date, end_date, ad_ids, countries, ad_types});
	},
	async deletePatch(id) {
		return patch_request("/patch/delete_patch", {id}, "application/json");
	},
	async getPatch(version, page, limit) {
		return patch_request("/patch/get_patch", {version, page, limit}, "application/json");
	},
	async getPatchVersions() {
		return patch_request("/patch/get_patch_version");
	},
	async getPatchExclude(id) {
		return patch_get("/patch/get_patch_exclude", {id});
	},
	async savePathExclude(params) {
		return patch_request("/patch/save_patch_exclude", params, "application/json");
	},
	async apps(page, len) {
		return ad_request("/open/apps", {page, len})
	},
	async queryAppInfo(package_name) {
		return ad_request("/open/query_app_info", {package_name});
	},
	async queryApp(text) {
		return ad_request("/open/query_app", {text});
	},
	async getAppVersions(id) {
		return ad_request("/open/get_app_versions", {id});
	},
	async getAppById(id) {
		return ad_request("/open/get_app_by_id", {id})
	},
	async saveAppVersionConfig(data) {
		return ad_request("/open/save_app_version_config", data, "application/json")
	},
	async getAppVersionChangeLogs(id, version) {
		return ad_request("/open/get_app_version_change_logs", {id, version});
	},
	async updateTopOnId(package_name, key, value) {
		return ad_request("/open/update_topon_apid", {package_name, key, value});
	},
	async updateAdId(package_name, key, value) {
		return ad_request("/open/update_app_apid", {package_name, key, value});
	},
	async updateAdIdName(id) {
		return request("/app/update_ad_id_name", { id });
	},
	async getJumpUrl(date_from, date_to) {
		return request("/open/ad/get_jump_url", { date_from, date_to });
	},
	async saveCollocation(params) {
		return request("/app/save_ad_collocation", params, "application/json");
	},
	async getAdCollocation(app_id) {
		return request("/app/get_ad_collocation", {app_id});
	},
	async updateAppCollocationEnable(app_id, enable) {
		return request("/app/update_app_collocation_enable", {app_id, enable});
	},
	async getCollocationLogs(id, page, limit) {
		return request("/open/ad/get_collocation_logs", {id, page, limit});
	},
	async getBudgetLogs(pid, page, page_len) {
		return request("/app/get_budget_logs", {pid, page, page_len});
	},
	async getTomorrowBudgetPlan(pid) {
		return request("/app/get_tomorrow_budget_plan", {pid});
	},
	async setAppCallbackRate(id, rate) {
		return request("/app/set_app_callback_rate", {id, rate});
	},
	async setAppCircuitRate(id, rate, enable) {
		return request("/app/set_app_circuit_rate", {id, rate, enable});
	},
	async copyCollocation(params) {
		return request("/app/copy_ad_collocation", params);
	},
	async resetCollocation(app_id) {
		return request("/app/reset_collocation", {app_id});
	},
	async getSumReports(params) {
		return request("/app/get_sum_report", params);
	},
	async getRoasPeriodData(package_name, date) {
		return request("/app/get_roas_period_data", {package_name, date});
	},
	async getAdGroups(package_name, country, uid, name, date_from, date_to, page, limit) {
		return request("/app/get_ad_groups", {package_name, country, uid, name, date_from, date_to, page, limit});
	},
	async getOverview(params) {
		return request("/app/get_overview", params);
	},
	async getGameOverview(params) {
		return request("/app/get_game_overview", params);
	},
	async getCompensation(params) {
		return request("/app/get_compensation", params);
	},
	async getCircuitBreakerLogs(game_id, page, limit) {
		return request("/app/get_ad_circuit_log", {game_id, page, limit});
	},
	async getMiAppIds() {
		return request("/app/get_mi_app_ids");
	},
	async updateAppConfig(id, config) {
		config.id = id;
		return request("/app/update_app_config", config);
	},
	async getCtrMonitor() {
		return request("/app/get_ctr_monitor");
	},
	async getAdmins() {
		return request("/app/get_admins");
	},
	async getAppAdConfig(package_name) {
		return request("/app/get_app_ad_config", {package_name});
	},
	async getRubbishMedia() {
		return request("/app/get_rubbish_media");
	},
	async getSelfMedia() {
		return request("/app/get_self_media");
	},
	async searchMedia(name) {
		return request("/app/search_media", {name});
	},
	async getAdvertisers() {
		return request("/app/get_advertisers");
	},
	async createAd(params) {
		return request("/app/create_ad", params, "application/json");
	},
	async getAdText(package_name) {
		return request("/app/get_ad_text", {package_name});
	},
	async getAdvList() {
		return request("/app/get_adv_list");
	},
	async saveAdPublish(data) {
		return request("/app/save_publish", data);
	},
	async updateAdPublish(data) {
		return request("/app/update_publish", data);
	},
	async deleteAdPublish(app_id) {
		return request("/app/delete_publish", {app_id});
	},
	async getPublishProject(name, page, limit) {
		return request("/app/get_publish_projects", {name, page, limit});
	},
	async getPublishDetails(app_id) {
		return request("/app/publish_details", {app_id});
	},
	async switchPublishProject(app_id, on) {
		return request("/app/switch_publish_project", {app_id, on});
	},
	async deleteRubbish(media_id) {
		return request("/app/delete_rubbish_media", {media_id});
	},
	async deleteAssets(id) {
		return request("/app/delete_publish_assets", {id});
	},
	async getAppErrorLog(package_name, date, version, page) {
		return request("/app/get_app_error_log", {package_name, date, version, page});
	},
	async getErrorAppVersions(package_name) {
		return request("/app/get_app_versions", {package_name});
	},
	async getAdConfig(key) {
		return request("/app/get_ad_config", {key});
	},
	async getCostReport(params) {
		return request("/app/get_cost_report", params);
	},
	async downloadCostReport(params) {
		return request_blob("/app/down_cost_report", params);
	},
	async getDashboardOverview() {
		return request("/app/get_dashboard");
	},
	async getOpAdvertisers() {
		return request("/app/get_op_advertisers");
	},
	async addOpAdvertisers(content) {
		return request("/app/add_op_advertisers", {content}, "application/json");
	},
	async getEcpmReport(date_from, date_end, country, ad_type) {
		return request("/app/get_ecpm_graph", {date_from, date_end, country, ad_type});
	},
	async getAbnormalPlacement() {
		return request("/app/get_abnormal_placement");
	},
	async getBlockedMediaIds(package_name) {
		return request("/app/ad/get_blocked_media_ids", {package_name});
	},
	async getAdmobWarning() {
		return request("/app/ad/get_admob_warning");
	},
	async getBids(package_name) {
		return request("/app/ad/get_bids", {package_name});
	},
	async saveBid(package_name, country, bid) {
		return request("/app/ad/save_bid", {package_name, country, bid});
	},

	async getAppVersionList(app_id) {
		return ad_request("/open/get_app_version_list", {app_id})
	},
	async getAppGlobalConfig(app_id) {
		return ad_request("/open/get_app_global_config", {app_id})
	},
	async saveGlobalConfig(params) {
		return ad_request("/open/save_global_config", params, "application/json");
	},
	async saveAdVersionConfig(params) {
		return ad_request("/open/save_ad_version_config", params, "application/json");
	},
	async getAdVersionConfig(app_id, version) {
		return ad_request("/open/get_ad_version_config", {app_id, version});
	},
	async getAppAdPlacement(app_id) {
		return ad_request("/open/get_app_ad_placement", {app_id});
	},
	async getAppAdPlacementVersionConfig(app_id, version) {
		return ad_request("/open/get_placement_version_config", {app_id, version});
	},
	async saveAdPlacement(params) {
		return ad_request("/open/save_app_ad_placement", params, "application/json");
	},
	async saveAdPlacementVersionConfig(params) {
		return ad_request("/open/save_app_ad_placement_version_config", params, "application/json");
	},
	async changePlaceStatus(id, status) {
		return ad_request("/open/change_ad_placement_status", {id, status});
	},
	async deletePlacement(id) {
		return ad_request("/open/delete_placement", {id});
	},
	async getPlatforms() {
		return ad_request("/open/get_platform");
	},
	async setPlatformArgs(app_id, platform, p_id, p_key) {
		return ad_request("/open/set_platform_args", {app_id, platform, p_id, p_key});
	},
	async getPlatformArgs(app_id) {
		return ad_request("/open/get_platform_args", {app_id});
	},
	async deletePlatform(app_id, platform) {
		return ad_request("/open/delete_platform", {app_id, platform});
	},
	async syncPlacementsToAllVersions(app_id, version) {
		return ad_request("/open/sync_placements_to_all_versions", {app_id, version});
	},
	async addAppVersion(app_id, version_name, version_code) {
		return ad_request("/open/add_app_version", {app_id, version_name, version_code});
	}
}
